.node {
  --node-padding-left: 0;

  display: flex;
  align-items: center;
  position: relative;

  padding: 3px var(--spacer);
  padding-left: var(--node-padding-left);
  border: 1px solid transparent;

  cursor: pointer;
}

.node--active {
  background-color: var(--blue-layout-050-selected);
}

.node--dropdown-open {
  background-color: var(--chart-050-hover);
}

.node--disabled {
  opacity: 0.7;
  cursor: default;
}

.drag-over {
  width: calc(100% - var(--node-padding-left));
}
